function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M403.525 216.949H65.085c-14.379 0-26.034-11.655-26.034-26.034s11.655-26.034 26.034-26.034h338.441v52.068z",
  fill: "#0071bc"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 247.322,
  cy: 173.559,
  r: 95.458,
  fill: "#fed856"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.051 269.017v216.949c0 14.379 11.655 26.034 26.034 26.034h381.831V216.949H65.085c-14.379 0-26.034-11.655-26.034-26.034v78.102z",
  fill: "#29abe2"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#cd9829"
}, /*#__PURE__*/React.createElement("path", {
  d: "M238.644 17.356H256v52.068h-17.356V17.356zM273.356 52.068h17.356V84.61h-17.356V52.068zM203.932 34.712h17.356V84.61h-17.356V34.712z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M420.881 312.407h34.712c9.589 0 17.356 7.767 17.356 17.356v69.424c0 9.589-7.767 17.356-17.356 17.356H325.424c-28.759 0-52.068-23.309-52.068-52.068 0-28.759 23.309-52.068 52.068-52.068h95.457z",
  fill: "#0071bc"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M65.085 216.949h17.356V512H65.085V216.949z",
  fill: "#fbb03b"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "#cd9829"
}, /*#__PURE__*/React.createElement("path", {
  d: "M273.356 17.356h17.356v17.356h-17.356V17.356zM203.932 0h17.356v17.356h-17.356V0z"
}));

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 325.424,
  cy: 364.475,
  r: 17.356,
  fill: "#fbb03b"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#cd9829"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 131.428v-9.936h-17.356v9.936c-13.017 4.053-20.28 17.885-16.236 30.894a24.713 24.713 0 0012.574 14.77l16.913 8.461a7.412 7.412 0 01-3.306 14.041h-2.534a7.43 7.43 0 01-7.411-7.411v-1.267h-17.356v1.267c.017 13.676 11.09 24.75 24.767 24.767h2.534c13.676 0 24.767-11.09 24.767-24.767a24.768 24.768 0 00-13.694-22.155l-16.913-8.461a7.412 7.412 0 013.306-14.041h2.534a7.43 7.43 0 017.411 7.411v1.267h17.356v-1.267A24.723 24.723 0 00256 131.428zM290.712 164.881h17.356v17.356h-17.356v-17.356zM186.576 164.881h17.356v17.356h-17.356v-17.356z"
}));

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.456217e0.svg";
export { ForwardRef as ReactComponent };